<script lang="ts">
export default {
  name: 'KkTag',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { KkIcon } from '../'
import type { IconName } from '../KkIcon/index.vue'

export interface Props {
  label: string
  iconName?: IconName
  color?: string
  clickable?: boolean
}

export interface Emits {
  (key: 'click', event: MouseEvent): void
}

const props = withDefaults(defineProps<Props>(), {
  color: 'primary',
})
const emits = defineEmits<Emits>()

const classes = computed(() => {
  const classes: string[] = ['tag']
  classes.push(`--${props.color}`)
  if (props.clickable) classes.push('--clickable')
  return classes
})

const iconColor = computed(() => {
  if (props.color === 'primary') return '#3A3B3F'
  return '#FFF'
})

const onClick = (event: MouseEvent) => {
  if (!props.clickable) return
  emits('click', event)
}
</script>

<template>
  <div :class="classes" @click="onClick($event)">
    <span v-if="props.iconName" class="tag__icon">
      <KkIcon :name="props.iconName" :color="iconColor" />
    </span>
    {{ props.label }}
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
@import "../../../../../stylesheets/biz_spa/foundation/_mixin.scss";
.tag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  margin-right: 4px;
  padding: 0 8px 1px;
  border-radius: 12px;
  color: #3A3B3F;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  &.--primary {
    background-color: #F5F6F9;
  }
  &.--secondary {
    background-color: #3A3B3F;
    color: #FFF;
    font-weight: bold;
  }
  &.--gray {
    opacity: .5;
    background-color: #3A3B3F;
    color: #FFF;
    font-weight: bold;
  }
  &.--clickable {
    cursor: pointer;
  }
  &__icon {
    margin-right: 4px;
  }
}
</style>
